import { handleActions } from 'redux-actions';
import { setStatementAnnotationsPosition } from 'store/actions/statement-summary/statement-annotations-update-actions';
import AnnotationPositionUpdate from 'models/api/statement-annotations-update-model';
import { resetAnnotationDisplayAndPositionOption } from 'store/actions/annotation-display-actions';

export default handleActions(
  {
    [setStatementAnnotationsPosition]: (annotationPosition, { payload }) => {
      return annotationPosition.setAnnotationPosition(payload);
    },
    [resetAnnotationDisplayAndPositionOption]: () => {
      return new AnnotationPositionUpdate();
    },
  },
  new AnnotationPositionUpdate(),
);
